<template>
    <b-table striped small show-empty :items="items" :fields="fields" class="table-borderless">
        <template slot="creationDate" slot-scope="row">
            {{ $d(row.item.creationDate, 'long') }}
        </template>
        <template slot="type" slot-scope="row">
            {{ $t(`report.types.${row.item.type || 'default'}`) }}
        </template>
        <template slot="actions" slot-scope="row">
            <b-dropdown variant="link">
                <template slot="button-content">
                    <dots-icon title="" />
                </template>
                <b-dd-item v-if="$store.getters.getUserRole === $appConfig.role.inspector" target="_blank" :to="{ name: 'childReportDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                <b-dd-item v-else target="_blank" :to="{ name: 'reportDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                <b-dd-item v-if="$store.getters.getUserRole === $appConfig.role.inspector" target="_blank" :to="{ name: 'childReportViewLog', params: row.item }">{{ $t('report.viewHistory') }}</b-dd-item>
                <b-dd-item v-else target="_blank" :to="{ name: 'reportViewLog', params: row.item }">{{ $t('report.viewHistory') }}</b-dd-item>
            </b-dropdown>
        </template>
        <template slot="empty">
            <div class="text-center">
                {{ $t('general.noData') }}
            </div>
        </template>
    </b-table>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'ReportListView',
    mixins: [ AppData ],
    props: {
        items: Array,
        getReports: Function
    },
    computed: {
        fields: function () {
            return [
                { key: 'creationDate', label: this.$t('report.createDate') },
                { key: 'type', label: this.$t('report.type') },
                { key: 'ccmFactoryNumber', label: this.$t('report.kkmFactoryNum') },
                { key: 'actions', label: this.$t('general.actions') }
            ]
        }
    }
}
</script>
